import fetch from '../../api/fetch'

/**
 *  Action to view a single Policy details
 *
 *  @param  {number} policyId [Policy ID]
 *  @param  {string} URL [/api/v1/policies/:policyId/view]
 *  @method GET
 */
export function getPolicyMTA(policyId: number) {

    return {
        type: 'GET_POLICY_MTA',
        payload: fetch(
            `/policies/${policyId}/full_info`
        ),
    }
}

/**
 *  Action to view a single Policy details
 *
 *  @param  {number} policyId [Policy ID]
 *  @param  {string} URL [/api/v1/policy/:policyId/mta]
 *  @method POST
 */
export function addMTA(policyId: number, body: any) {

    return {
        type: 'ADD_MTA',
        payload: fetch(
            `/policies/${policyId}/mta`,
            { method: 'POST', body: { 'mta': body } }
        ),
    }
}

// /**
//  *  Action to view a single Policy details
//  *
//  *  @param  {number} policyId [Policy ID]
//  *  @param  {number} mtaId [MTA ID]
//  *  @param  {string} URL [/api/v1/policy/:policyId/mta/:mtaId]
//  *  @method GET
//  */
// export function getMTA(policyId: number, mtaId: number) {

//     return {
//         type: 'GET_MTA',
//         payload: fetch(
//             `/policy/${policyId}/mta/${mtaId}`
//         ),
//     }
// }

/**
 *  Action to view a single Policy details
 *
 *  @param  {number} policyId [Policy ID]
 *  @param  {number} mtaId [MTA ID]
 *  @param  {string} URL [/api/v1/policy/:policyId/mta/:mtaId/preview]
 *  @method GET
 */
export function getMTAPreview(policyId: number, mtaId: number) {

    return {
        type: 'GET_MTA_PREVIEW',
        payload: fetch(
            `/policies/${policyId}/mta/${mtaId}/preview`
        ),
    }
}

/**
 *  Action to Bind MTA
 *
 *  @param  {number} policyId [Policy ID]
 *  @param  {number} mtaId [MTA ID]
 *  @param  {string} URL [/api/v1/policy/:policyId/mta/bind]
 *  @method POST
 */
export function bindMTA(policyId: number, mtaId: number) {

    return {
        type: 'BIND_MTA',
        payload: fetch(
            `/policies/${policyId}/mta/bind`,
            { method: 'POST', body: { 'mtaId': mtaId } }
        ),
    }
}

/**
 *  RESET MTA
 */
export function resetMTA() {

    return {
        type: 'RESET_MTA',
    }
}

/**
 *  Remove PolicySubmit
 */
export function removePolicySubmit() {

    return {
        type: 'REMOVE_POLICY_SUBMIT',
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/policies/mta.ts